export const STATUS_META = {
  READY: { label: "Ready", color: "#00A651", bg: "#E6F6EE", text: "#00733A" },
  AT_RISK: { label: "At Risk", color: "#F5A623", bg: "#FEF4E2", text: "#8A5A00" },
  NOT_READY: { label: "Not Ready", color: "#D0021B", bg: "#FCE8EA", text: "#9A0114" },
  NA: { label: "N/A", color: "#9BA3AF", bg: "#F0F2F5", text: "#5B6472" },
};

export const STREAM_COLORS = {
  SUBSCRIBER: "#0075C9",
  TECHNICIAN: "#00A651",
  EXECUTIVE: "#7B4FA8",
  SHARED: "#475569",
  SUPPLIER_WAREHOUSE: "#B45309",
  LOGISTICS_TRUCKS: "#0E7490",
  blue: "#0075C9",
  green: "#00A651",
  purple: "#7B4FA8",
  slate: "#475569",
};

export const CRIT_COLORS = {
  "Very High": "#D0021B",
  High: "#F5A623",
  Medium: "#E8B90A",
  Low: "#9BA3AF",
};

export const statusMeta = (s) => STATUS_META[s] || STATUS_META.NA;

export const STREAM_SHORT = {
  SUBSCRIBER: "Subscriber",
  TECHNICIAN: "Technician",
  EXECUTIVE: "Executive",
  SHARED: "Shared",
  SUPPLIER_WAREHOUSE: "Supplier",
  LOGISTICS_TRUCKS: "Logistics",
};

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
}

export function daysAgo(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  const asOf = new Date("2026-08-18");
  return Math.round((asOf - d) / 86400000);
}
